import CorsErrorModal from './corsErrorModal';
import AuthRequiredModal from './authRequiredModal';
import SearchBarWithResults from './searchBarWithResults';

export default {
	CorsErrorModal,
	AuthRequiredModal,
	SearchBarWithResults
};
